import { ReactNode } from 'react'

import { cn } from '~/utils/tailwind-utils'

// md is the switch point because the extension opens Connect as a 450px popup (splits-connect content.ts).
// The bar is static, not sticky, because PageLayout's overflow-x-hidden wrapper stops sticky from working.
export const ConnectFooter = ({
  children,
  stacked = false,
}: {
  children: ReactNode
  stacked?: boolean
}) => (
  <div className="fixed bottom-0 left-0 right-0 bg-white p-4 md:static md:px-0 dark:bg-black">
    <div
      className={cn(
        'mx-auto flex w-full max-w-lg',
        stacked ? 'flex-col space-y-2' : 'items-center justify-between',
      )}
    >
      {children}
    </div>
  </div>
)
